/* eslint-disable jira/filename-case */
// this is copied from NIN https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue-navigator/actions-common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a

export const isFilterId = (value?: string): boolean => value !== undefined && /^-?\d+$/.test(value);
